import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';
import { Calendar } from './calenderTypes';


export const createTask = createAsyncThunk(
    'calendar/createTask',
    async (data: Calendar, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/calendar', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create task');
        }
    }
);

export const fetchAllTask = createAsyncThunk(
    'calendar/fetchAllTask',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/calendar');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create task');
        }
    }
);

export const fetchtaskByDate = createAsyncThunk(
    'calendar/fetchtaskBydate',
    async (date: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/calendar/task?date=${date}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Goal');
        }
    }
);

export const updatetask = createAsyncThunk(
    'calendar/update',
    async ({ id, data }: { id: number; data: Partial<any> }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/calendar/task/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update calendar');
        }
    }
);

export const deletetask = createAsyncThunk(
    'calendar/delete',
    async (Id: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/calendar/task/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Task');
        }
    }
);
export const getTaskById = createAsyncThunk(
    'calendar/getbyId',
    async (Id: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/calendar/task/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to Fetch Task');
        }
    }
);
export const getTaskByEmployeeId = createAsyncThunk(
    'calendar/getTaskByEmployeeId',
    async (employeeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/calendar/employee/${employeeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to Fetch Task');
        }
    }
);
export const getBirthdayByDate = createAsyncThunk(
    'calendar/getTaskByEmployeeId',
    async (date: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/calendar/birthday/${date}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to Fetch Birthday');
        }
    }
);
// export const createMeetLink = createAsyncThunk(
//   "meeting/createMeetLink",
//   async (formData: any, { rejectWithValue, getState }) => {
//     try {
//       const state: any = getState();
//       const user = state.auth.user;
//       const employees = state.employee.employees;

//       const payload = {
//         userId: user.UserId,
//         summary: formData.Name,
//         start: formData.fromDate,
//         end: formData.toDate,
//         attendees: formData.attendees.map((id: any) => {
//           const emp = employees.find((e: any) => Number(e.EmployeeID) === Number(id));
//           return { email: emp.Email };
//         })
//       };

//       console.log("Final payload:", payload);

//       const { data } = await employeeServiceApiInstance.post(
//         "/calendar/create-event",
//         payload,
//         {
//           headers: {
//             "x-company-code": user.companyCode
//           }
//         }
//       );

//       return data.meetLink;

//     } catch (err: any) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const createGoogleEvent = createAsyncThunk<
    any, // return type (replace with actual type if known)
    { userId: string, summary: string, start: string, end: string, attendees?: any[] }, { rejectValue: any }>("calendar/createGoogleEvent",
        async ({ userId, summary, start, end, attendees }, { rejectWithValue }) => {
            try {
                const res = await employeeServiceApiInstance.post("/calendar/create-event", {
                    userId,
                    summary,
                    start,
                    end,
                    attendees
                });
                return res.data;
            } catch (err: any) {
                return rejectWithValue(err.response?.data);
            }
        }
    );


export const checkGoogleConnection = createAsyncThunk(
    "calendar/checkGoogleConnection",
    async (
        { userId, dbName }: { userId: any; dbName: any; },
        { rejectWithValue }
    ) => {
        try {
            const response = await employeeServiceApiInstance.get(
                `/calendar/check-connection?userId=${userId}&dbName=${dbName}`,
                {
                    headers: { "x-company-code": userId.companyCode }
                }
            );

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deleteGoogleEvent = createAsyncThunk(
    "calendar/deleteGoogleEvent",
    async ({ userId, eventId, companyCode, dbName }: { userId: any, eventId: any, companyCode: any, dbName: any }, 
        { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post("/calendar/delete-event", { userId, eventId, dbName, companyCode },
                {
                    withCredentials: true,
                    headers: { "x-company-code": companyCode },
                    params: { companyCode },
                });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || "Google delete failed");
        }

    }
);

